<script setup>
import { Tooltip as VueTooltip } from 'floating-vue';
import { useRouter } from 'vue-router';
import CFRoundedButton from '@/ui/RoundedButton/CFRoundedButton.vue';

const router = useRouter();

const redirectToChangelogs = () => {
    const changelogUrl = router.resolve({ name: 'changelog' }).href;
    window.open(changelogUrl, '_blank');
};
</script>

<template>
    <VueTooltip theme="dark-tooltip">
        <CFRoundedButton
            icon="time-clock-file"
            color="primary"
            size="lg"
            @click="redirectToChangelogs"
        />

        <template #popper>
            <div class="flex flex-col items-center">
                <strong>{{ $t('shortcuts.changelog') }}</strong>
            </div>
        </template>
    </VueTooltip>
</template>
